import { createFileRoute } from "@tanstack/react-router";
import PageGate from "@/components/auth/PageGate";
import EquityDetail from "@/pages/EquityDetail";

export const Route = createFileRoute("/_app/markets/stocks/$symbol")({
  component: () => (
    <PageGate pageKey="tokens"><EquityDetail /></PageGate>
  ),
});
